import type { IconSvgObject } from './types';

const KeyframeTopIcon: IconSvgObject = [
  ["path", { d: "M3 3L12 3M12 3L21 3M12 3V6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.2041 20.6409C11.6309 21.1197 12.3691 21.1197 12.7959 20.6409L16.7203 16.238C17.0932 15.8195 17.0932 15.1805 16.7203 14.762L12.7959 10.3591C12.3691 9.8803 11.6309 9.8803 11.2041 10.3591L7.27972 14.762C6.90676 15.1805 6.90676 15.8195 7.27972 16.238L11.2041 20.6409Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default KeyframeTopIcon;
